import React from "react";
import { Modal, ModalBody } from "reactstrap";
import CreateResourceComponent from "../CreateResourceComponent";

const AddProviderModal = ({
  isOpen,
  toggle,
  isEdit,
  editDetails,
  fetchAllProvider,
  services,
}) => {
  const _closeModal = () => {
    toggle();
  };

  return (
    <>
      <Modal isOpen={isOpen} toggle={_closeModal} scrollable size="md">
        <ModalBody>
          <CreateResourceComponent
            services={services}
            isEdit={isEdit}
            editDetails={editDetails}
            fetchAllProvider={fetchAllProvider}
            toggle={toggle}
          />
        </ModalBody>
      </Modal>
    </>
  );
};

export default AddProviderModal;
